// extracted by mini-css-extract-plugin
export default {"ColorPickerContent":"_ColorPickerContent--JAtwW","FormattingTrigger":"_FormattingTrigger--ViE7H","Bolded":"_Bolded--bcOZs"};